module.exports = __webpack_public_path__ + "static/img/9.b7722abc.png";